import { Stack } from 'expo-router';

export default function GymLayout() {
  return (
    <Stack>
      <Stack.Screen name="leaderboard" options={{ headerShown: false }} />
      <Stack.Screen name="[gymId]" options={{ headerShown: false }} />
      <Stack.Screen name="claim" options={{ headerShown: false }} />
    </Stack>
  );
}
